import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const QRCodesList = lazy(() => import("../../container/qrcodes/qrcodesList"));
const AddQRCode = lazy(() =>
  import("../../container/qrcodes/components/createQRCodeForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<QRCodesList />} />
      <Route path="/add-qrcode" element={<AddQRCode />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
